import React from 'react';
import { Icon, Text } from '../../Atoms'
import { AffiliationRecapSummaryMolecule } from '../../Molecules';

function MoleculeAffiliationRecap(props) {
    return (
        <div className="molecule-affiliation-recap-container">
            <div className="molecule-affiliation-recap-first-container">
                <Text text="Vos mensualités" className="molecule-affiliation-recap-title" />
                <div className="molecule-affiliation-recap-salary-container">
                    <Text text="Salaire mensuel brut €" className="molecule-affiliation-recap-salary" />
                    <div className="molecule-affiliation-recap-salary-price-container">
                        <Icon icon="Euro" size="8px" className="molecule-affiliation-recap-salary-price-icon" />
                        <Text text="2000" className="molecule-affiliation-recap-salary-price" />
                    </div>
                </div>
                <div className="molecule-affiliation-recap-base">
                    Base : <span className="molecule-affiliation-recap-base-description">Pour vous et votre famille</span>
                </div>
            </div>
            <div className="molecule-affiliation-recap-second-container">
                <Text text="Récapitulatif" className="molecule-affiliation-recap-title" />
                <AffiliationRecapSummaryMolecule
                    title="Base"
                    data="199,58€"
                />
                <AffiliationRecapSummaryMolecule
                    title="Prise en charge entreprise"
                    data="-99,79€"
                />
                <AffiliationRecapSummaryMolecule
                    title="TOTAL TTC/mois"
                    data="= 99,79€"
                />
            </div>
        </div>
    );
}

export default MoleculeAffiliationRecap;
